window.productDetailsHandler = function () {
  $(document).ready(function () {
    bindProductDetailsEvents();
  });

  // Longer lead time - modal visibility
  const bindProductDetailsEvents = () => {
    const modalSelectors = ['.jsModalUnavailableProd', '.jsModalLegacyProduct'];
    modalSelectors.forEach((selector) => {
      const modal = $(selector);
      const modalVisible = modal.data('visible');
      const modalVisibleBoolean = $.parseJSON(modalVisible.toLowerCase());
      if(modalVisibleBoolean) {
        modal.addClass('active')
      }
    });
  }
};
